import {createErrorAction} from './utils';

const TYPES = {
    GET_HIGHLIGHTS: 'GET_HIGHLIGHTS',
    GET_HIGHLIGHTS_COMPLETE: 'GET_HIGHLIGHTS_COMPLETE',
    GET_HIGHLIGHTS_FAILED: 'GET_HIGHLIGHTS_FAILED'
};

export default {
    TYPES,

    getHighlights: payload => ({
        type: TYPES.GET_HIGHLIGHTS,
        payload
    }),

    getHighlightsSuccess: payload => ({
        type: TYPES.GET_HIGHLIGHTS_COMPLETE,
        payload
    }),

    getHighlightsFailed: createErrorAction(TYPES.GET_HIGHLIGHTS_FAILED)
};
